/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  Modal,
  Table,
  Tooltip,
  Typography,
  Switch,
  Skeleton,
  Badge,
} from "antd";
import {
  SettingOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  // FileExcelOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
// import { salesHeaders } from "./data";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePaymentOutList,
  loadPaymentOutList,
} from "../../store/payment-out/actions";
// import { BiRightArrowAlt } from "react-icons/bi";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import { loadPrefixSettingsList } from "../../store/expenses/actions";
import api from "../../helpers";

const PaymentIn = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const { RangePicker } = DatePicker;

  //state initial
  // const [salesTab, setSalesTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [search, setSearch] = useState("");

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  console.log(userId, "userId");
  const salesInvoiceList = { organizationId: organizationId };
  const salesPrefixList = {
    organizationId: organizationId,
    isType: "isPaymentOut",
  };
  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadPaymentOutList(salesInvoiceList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { payment_out_list = [] } = useSelector((state) => state.PaymentOut);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);

  //States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [paymentData, setPaymentData] = useState({
    prefix: "",
    seqNo: "",
  });

  const media = useMedia();
  const handleChange = (e) => {
    setPaymentData({
      ...paymentData,
      [e.target.name]: e.target.value,
    });
  };

  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //header columns

  const HeaderData = [
    {
      key: "paymentDate",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "paymentDate",
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      key: "paymentNo",
      title: <p className="header-sales-invoice font-semibold">Payment No</p>,
      dataIndex: "paymentNo",
    },
    {
      key: "vendorName",
      title: <p className="header-sales-invoice font-semibold">Vendor Name</p>,
      dataIndex: "vendorName",
    },
    {
      key: "enterPaymentAmount",
      title: <p className="header-sales-invoice font-semibold">Amount</p>,
      dataIndex: "enterPaymentAmount",
    },
    {
      key: "status",
      title: <p className="header-sales-invoice font-semibold">Status</p>,
      dataIndex: "status",
    },
  ];

  const paymentInvoiceRoutes = (data) => {
    history.push({
      pathname: "/payment-out/data",
      state: {
        paymentData: data,
      },
    });
  };

  //purchase rows

  const [paymentOutRows, setPaymentOutRows] = useState([
    {
      _id: "",
      key: "",
      accountId: "",
      // accountId: data.accountId,
      paymentModeId: "",
      paymentModeName: "",
      paymentNoValue: "",
      purchaseInvoices: [],
      enterPaymentAmount: "",
      paymentNo: "",
      paymentDate: "",
      createdAt: "",
      createdBy: "",
      notes: "",
      organizationId: "",
      transActionType: "",
      partyId: "",
      vendorName: "",
      vendorNameValue: "",
      status: "",
    },
  ]);

  console.log(payment_out_list, "payment_out_list");
  //data table
  const paymentDataTable =
    payment_out_list && payment_out_list.length > 0
      ? payment_out_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            accountId: data.accountId,
            // accountId: data.accountId,
            paymentModeId: data.paymentModeId,
            paymentModeName: data.paymentModeName,
            paymentNoValue: data.paymentNo,
            purchaseInvoices: data.purchaseInvoices,
            enterPaymentAmount: (
              <div className="flex">
                <p>{"₹ "}</p>
                <h1
                  className="cursor-pointer ml-1 header-sales-invoice"
                  onClick={() => paymentInvoiceRoutes(data)}
                >
                  {data.enterPaymentAmount}
                </h1>
              </div>
            ),
            paymentNo: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => paymentInvoiceRoutes(data)}
              >
                {data.paymentNo}
              </h1>
            ),
            paymentDate: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => paymentInvoiceRoutes(data)}
              >
                {data.paymentDate
                  ? moment(data.paymentDate).format("DD-MM-YYYY")
                  : "--"}
              </h1>
            ),
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            notes: data.notes,
            organizationId: data.organizationId,
            transActionType: data.transActionType,
            partyId: data.partyId,
            vendorName: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => paymentInvoiceRoutes(data)}
              >
                {data.vendorName}
              </h1>
            ),
            vendorNameValue: data.vendorName,
            status: (
              <Badge
                className={
                  data.status &&
                  data.status &&
                  data.status.statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                onClick={() => paymentInvoiceRoutes(data)}
              >
                {data.status && data.status && data.status.statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (paymentDataTable && paymentDataTable.length > 0) {
      setPaymentOutRows(paymentDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment_out_list]);

  //expand row
  const expandColumns = [
    {
      title: <p className="header-expand-purchase-invoice">Invoice Date</p>,
      dataIndex: "siDate",
      key: "siDate",
    },
    {
      title: <p className="header-expand-purchase-invoice">Invoice No</p>,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: <p className="header-expand-purchase-invoice">Due Date</p>,
      key: "dueDate",
      dataIndex: "dueDate",
    },
    {
      title: <p className="header-expand-purchase-invoice">Received Amount</p>,
      dataIndex: "amountSettled",
      key: "amountSettled",
    },
    {
      title: <p className="header-expand-purchase-invoice">Balance Amount</p>,
      key: "invoicePendingAmount",
      dataIndex: "invoicePendingAmount",
    },
    {
      title: <p className="header-expand-purchase-invoice">Amount</p>,
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
    },
  ];

  const expandedRowRender = (row) => {
    // console.log(row, "row");
    const expandRowData =
      row && row.purchaseInvoices.length > 0
        ? row.purchaseInvoices.map((data) => {
            return {
              amountSettled: "₹ " + data.amountSettled,
              dueDate: moment(data.dueDate).format("DD-MM-YYYY"),
              invoiceAmount: "₹ " + data.invoiceAmount,
              invoiceNumber: data.invoiceNumber,
              invoicePendingAmount: "₹ " + data.invoicePendingAmount,
              siDate: moment(data.siDate).format("DD-MM-YYYY"),
              siId: data.siId,
              _id: data._id,
            };
          })
        : [];
    return (
      <Table
        columns={expandColumns}
        dataSource={expandRowData}
        pagination={false}
        rowClassName={"header-expand-purchase-invoice-column"}
      />
    );
  };

  //data table
  const hasSelected = selectedRowKeys.length > 0;

  const handleSearch = (event) => {
    const filteredRows = paymentDataTable
      .filter((row) =>
        row.vendorNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPaymentOutRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  // console.log(paymentOutRows, "paymentOutRows");
  const [deletePaymentInModal, setDeletePaymentInModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //deletPurchase api integrations
  const deletePaymentOutApi = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: organizationId,
      paymentOutId: selectedRowKeys.length > 0 ? selectedRowKeys[0] : "",
      // selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deletePaymentOutList(itemListData));
    setTimeout(() => {
      dispatch(loadPaymentOutList(salesInvoiceList));
      setDeletePaymentInModal(false);
      setSelectedRowKeys([]);
      toast.error("Payment Out deleted successfully");
    }, 1000);
  };
  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);
  //Prefix settings list
  const createPrefixSettings = () => {
    if (paymentData.prefix && paymentData.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 4000);
      const prefixList = {
        organizationId: organizationId,
        prefix: paymentData.prefix,
        sequenceNo: paymentData.seqNo,
        isType: "isPaymentOut",
        isEnable: invoiceShow === true ? true : false,
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(salesPrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable === true) {
      setPaymentData({
        ...paymentData,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      setInvoiceShow(true);
    } else {
      setPaymentData({
        ...paymentData,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(search),
    message: "Are you sure you want to leave?",
  });
  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Payment Out | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] mt-2 font-semibold"
              >
                Payment Out
              </h1>
            </div>
            <div className="flex">
              {/* <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your party specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>
              </Dropdown> */}
              <Tooltip
                title="Easily add the Payment Out settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => {
                    setSettingsFieldModal(true);
                    dispatch(loadPrefixSettingsList(salesPrefixList));
                  }}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "sales-invoices-main-large-device"
              : windowDimensions.height > 830
              ? "payment-in-home-card-extra-infinite-device"
              : windowDimensions.height < 450
              ? "payment-in-home-card-mobile-device"
              : "sales-invoices-main"
          }
        >
          {/* purchase input section with bulk actions */}
          <Col span={24} className="sales-invoice-orders mt-3 mb-2">
            <Row className="sales-invoice-filters-main ml-4">
              <div className="sales-invoice-filters">
                {loading ? (
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <Skeleton.Input
                      style={{
                        width: "100%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <div className="filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="large"
                            placeholder="Search Vendor"
                            style={{
                              fontFamily: "Poppins",
                              minHeight: "35px",
                              fontSize: "11px",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                    </Tooltip>
                  </>
                )}
              </div>
              <div className="flex">
                {loading ? (
                  <Skeleton.Input
                    style={{
                      paddingRight: "25px",
                      marginRight: "25px",
                      width: "90%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[blueviolet] p-5 text-[white] mr-4"
                  >
                    <Link
                      to={{
                        pathname: "/create-payment-out",
                        state:
                          payment_out_list && payment_out_list.length > 0
                            ? payment_out_list.length
                            : 1,
                      }}
                    >
                      Create Payment Out
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pl-4 pr-4 pb-1">
            {hasSelected ? (
              <Row className="flex justify-between mb-2">
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "5px 10px",
                  }}
                  className="mb-1"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
                {selectedRowKeys.length > 0 ? (
                  <Col>
                    <Tooltip title="Delete Payment Out" placement="topLeft">
                      <div
                        onClick={() => setDeletePaymentInModal(true)}
                        className="cursor-pointer border border-1 p-[8px] rounded-md"
                      >
                        <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                      </div>
                    </Tooltip>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )}
          </Col>
          <Col
            span={24}
            className={
              media === "xxl"
                ? "pt-7 pr-4 pl-4 sales-invoice-orders mt-2"
                : "pt-5 pr-4 pl-4 sales-invoice-orders  mt-2"
            }
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                paymentOutRows &&
                paymentOutRows.length > 0 &&
                !isEmpty(paymentOutRows[0].vendorName)
                  ? paymentOutRows
                  : []
              }
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandAllRows: false,
              }}
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              rowSelection={{
                selectedRowKeys,
                onSelectAll: (selectedRowKeys, selectedRows, row) => {
                  const newSelecteds = selectedRows.map((n) => n._id);
                  setSelectedRowKeys(newSelecteds);
                },
                onSelect: (selectedRowKey, selectedRows, row) => {
                  const selectedIndex = selectedRowKeys.indexOf(
                    selectedRowKey._id
                  );
                  let newSelecteds = [];

                  if (selectedIndex === -1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys,
                      selectedRowKey._id
                    );
                  } else if (selectedIndex === 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(1)
                    );
                  } else if (selectedIndex === selectedRowKeys.length - 1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, -1)
                    );
                  } else if (selectedIndex > 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, selectedIndex),
                      selectedRowKeys.slice(selectedIndex + 1)
                    );
                  }
                  setSelectedRowKeys(newSelecteds);
                },
              }}
              scroll={{ x: 765 }}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Payment Out Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Payment Out Prefix & Payment Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1">Prefix</Typography>

                  <Input
                    name="prefix"
                    value={paymentData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(paymentData.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography className="mb-1">Sequence Number</Typography>

                  <Input
                    name="seqNo"
                    value={paymentData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(paymentData.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1">
                    Payment In Number:{" "}
                    {paymentData.prefix && paymentData.seqNo
                      ? paymentData.prefix + "" + paymentData.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      {/* Delete purchase modal */}

      <Modal
        open={deletePaymentInModal}
        onOk={() => {
          deletePaymentOutApi();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Payment`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setDeletePaymentInModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these Payment Out?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected Payment Out will be deleted from the Payment Out
            Inventory. Once deleted you will not be able to restore these sales
            invoice.
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(search)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

PaymentIn.propTypes = {
  location: PropTypes.any,
};

export default PaymentIn;
